export default "__VITE_ASSET__Btf4GI$3__"